import React, { useState, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button, Icon } from '@blueprintjs/core';
import type { NavItem } from '../../types';
import './Navbar.scss';

const navItems: NavItem[] = [
  { label: 'Home', path: '/' },
  { label: 'Living Benefits', path: '/living-benefits' },
  { label: 'About', path: '/about' },
  { label: 'Contact', path: '/contact' },
];

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = useCallback(() => {
    setIsMenuOpen(prev => !prev);
  }, []);

  const closeMenu = useCallback(() => {
    setIsMenuOpen(false);
  }, []);

  const isActive = (path: string): boolean => {
    return location.pathname === path;
  };

  return (
    <nav className="navbar" role="navigation" aria-label="Main navigation">
      <div className="navbar__container">
        <Link to="/" className="navbar__brand" onClick={closeMenu}>
          <img
            src="/explore_complete.png"
            alt="Rolita Cargill Logo"
            className="navbar__logo"
          />
          <div className="navbar__brand-text">
            <span className="navbar__brand-name">Rolita Cargill</span>
            <span className="navbar__brand-tagline">Living Benefits Specialist</span>
          </div>
        </Link>

        <button
          className={`navbar__toggle ${isMenuOpen ? 'navbar__toggle--open' : ''}`}
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-controls="navbar-menu"
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
        >
          <span className="navbar__toggle-bar"></span>
          <span className="navbar__toggle-bar"></span>
          <span className="navbar__toggle-bar"></span>
        </button>

        <div
          id="navbar-menu"
          className={`navbar__menu ${isMenuOpen ? 'navbar__menu--open' : ''}`}
        >
          <ul className="navbar__list">
            {navItems.map((item) => (
              <li key={item.path} className="navbar__item">
                <Link
                  to={item.path}
                  className={`navbar__link ${isActive(item.path) ? 'navbar__link--active' : ''}`}
                  onClick={closeMenu}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>

          <div className="navbar__cta">
            <Button
              intent="primary"
              large
              rightIcon={<Icon icon="arrow-right" />}
              onClick={() => {
                closeMenu();
                window.location.href = '/contact';
              }}
            >
              Get a Free Quote
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
